<template>
  <div>
    <label>Customer <sub v-if="showOrgNames">Organisation</sub></label>
    <multiselect
      v-if="customers"
      :allow-empty="false"
      :value="customer"
      label="name"
      :filterable="true"
      :options="customers"
      track-by="uuid"
      select-label=""
      deselect-label=""
      placeholder="Select a customer..."
      @select="selectCustomer">
      <template slot="singleLabel" slot-scope="props">
        {{ props.option.name }}
        <span v-if="showOrgNames && props.option.organisation" class="organisation-label">{{ props.option.organisation.name }}</span>
      </template>
      <template slot="option" slot-scope="props">
        {{ props.option.name }}
        <span v-if="showOrgNames" class="organisation-label">{{ props.option.organisation.name }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'customer',
    event: 'input',
  },
  props: {
    customer: {
      type: null,
      default: null,
    },
    customers: {
      type: Array,
      required: false,
      default: null,
    },
    showOrgNames: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    selectCustomer(customer) {
      this.$emit('input', customer);
    },
  },
};
</script>

<style scoped>

  .multiselect--active {
      z-index: 1000;
  }

  .organisation-label {
    font-size: xx-small;
    padding: 2px;
    color: #000;
  }

</style>
